import { ReactNode, FC, useCallback } from 'react';
import { Form } from 'react-final-form';

import { Option } from '@beeline/design-system-react/extracted-styles';

import { EmployeeInfo } from 'src/components/EmployeeInfo/EmployeeInfo';
import { Section } from 'src/components/Section/Section';
import { SpaceInfoComponent } from 'src/components/SpaceInfo/SpaceInfo';
import { bookParking } from 'src/store/parking/services';
import { useAppDispatch } from 'src/store/useAppDispatch';
import { Parking } from 'src/types';

import { BookedForField } from './BookedForField/BookedForField';
import { BookingData } from './BookingData';
import { CarFields } from './CarFields';
import classes from './Fields.module.scss';
import { NeedPassCheckbox } from './NeedPassCheckbox';
import { TimeInterval } from './TimeInterval';

interface AdminBookingFormValues {
  guest: boolean;
  model: string;
  number: string;
  needPass: boolean;
  responsible: Option<string> | null;
  guestName: string;
}

const adminInitialValues: AdminBookingFormValues = {
  guest: false,
  model: '',
  number: '',
  needPass: false,
  responsible: null,
  guestName: '',
};

export interface AdminBookingFieldsProps {
  parking: Parking;
}

export const AdminBookingFields: FC<AdminBookingFieldsProps> = ({
  parking,
}) => {
  return (
    <>
      <BookingData guest={parking.guest} />

      {parking.spaceAdministrator && (
        <Section title='Ответственный по блоку' testId='responsibleSection'>
          <EmployeeInfo
            employeeNumber={parking.spaceAdministrator}
            testId='responsible'
          />
        </Section>
      )}
      {parking.spaceId && (
        <Section title='Закреплено за блоком' testId='responsibleSection'>
          <SpaceInfoComponent spaceId={parking.spaceId} />
        </Section>
      )}

      {parking.responsibleEmployeeNumber && (
        <Section title='Закреплено за сотрудником' testId='responsibleSection'>
          <EmployeeInfo
            employeeNumber={parking.responsibleEmployeeNumber}
            testId='responsible'
          />
        </Section>
      )}

      <TimeInterval status={parking.status} />

      <Section
        title='Данные для бронирования'
        testId='parkingDataSection'
        contentClassName={classes.fields}
      >
        <BookedForField />
        <CarFields />
        <NeedPassCheckbox />
      </Section>
    </>
  );
};

export interface AdminBookingProps {
  children?: ReactNode;
}

export const AdminBooking: FC<AdminBookingProps> = ({ children }) => {
  const dispatch = useAppDispatch();

  const book = useCallback(
    async (values: AdminBookingFormValues) => {
      return dispatch(
        bookParking({
          responsible: values.guest
            ? undefined
            : (values.responsible?.id as string),
          guestName: values.guest ? values.guestName : undefined,
          carModel: values.model,
          carNumber: values.number,
          needPass: values.guest ? true : values.needPass,
        }),
      ).unwrap();
    },
    [dispatch],
  );

  return (
    <Form onSubmit={book} initialValues={adminInitialValues}>
      {() => children}
    </Form>
  );
};
